/**
 * HYPERPAY_1002 U 卡到账站内信：C 端列表通常不返回 templateId，
 * 用已渲染文案识别；跳转卡片余额，不走钱包入账页。
 * /spikex-card 是 Next i18n 路由，必须走 router.push，不能用 getUrl（不会拼 lang）。
 */
import { pushSpikexCardRoute } from "@/utils/spikexCardNav";

export const HYPERPAY_CARD_DEPOSIT_TEMPLATE_ID = "HYPERPAY_1002";
export const SPIKEX_CARD_BALANCE_PATH = "/spikex-card";

const TITLE_MARKERS = [
  "U卡充值到账",
  "U卡充值到帳",
  "Card deposit credited",
  "Depósito no cartão creditado",
];

const CONTENT_MARKERS = [
  "虚拟卡已到账",
  "虛擬卡已到帳",
  "credited to your virtual card",
  "creditado no seu cartão virtual",
];

function letterTemplateId(item) {
  const raw =
    item?.templateId ??
    item?.template_id ??
    item?.letterTemplateId ??
    item?.templateCode ??
    "";
  return String(raw).trim().toUpperCase();
}

export function isHyperpayCardDepositLetter(item) {
  if (!item || typeof item !== "object") return false;
  if (letterTemplateId(item) === HYPERPAY_CARD_DEPOSIT_TEMPLATE_ID) return true;
  const title = String(item.title || "");
  const content = String(item.content || "");
  if (TITLE_MARKERS.some((marker) => title.includes(marker))) return true;
  return CONTENT_MARKERS.some((marker) => content.includes(marker));
}

export function hasUserLetterClickAction(item) {
  return isHyperpayCardDepositLetter(item) || Boolean(item?.webClickUrl);
}

export function navigateHyperpayCardDepositLetter(item, router) {
  if (!isHyperpayCardDepositLetter(item)) return false;
  pushSpikexCardRoute(router, SPIKEX_CARD_BALANCE_PATH);
  return true;
}

export function openUserLetterClick(item, router) {
  if (navigateHyperpayCardDepositLetter(item, router)) return true;
  const url = item?.webClickUrl;
  if (url && typeof window !== "undefined") {
    window.open(url, "_blank");
    return true;
  }
  return false;
}
